<!-- =========================================================================================
  File Name: EquipmentOperator.vue
  Description: Link Operators (Employees) to specific Equipment they are authorised to use
========================================================================================== -->

<template>
  <div>
    <equipment-operator-sidebar :isSidebarActive="addSidebarActive" @closeSidebar="toggleAddSidebar"
      @saved="onLinkSaved" />
    <equipment-operator-bulk-edit-sidebar :isSidebarActive="bulkEditSidebarActive" @closeSidebar="toggleBulkEditSidebar"
      @saved="onLinkSaved" />

    <vx-card ref="MainCard">
      <div>
        <vs-table ref="gridTable" v-model="selected" pagination :max-items="itemsPerPage" search
          :data="filteredLinks" class="vs-con-loading__container">
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
            <vs-button class="rounded-lg mr-2" color="rgb(125, 51, 255)" type="filled" @click="toggleAddSidebar(true)"
              icon-pack="feather" icon="icon-plus-square">
              Add Link
            </vs-button>
            <vs-button class="rounded-lg mr-2" color="rgb(62, 201, 214)" type="filled"
              @click="toggleBulkEditSidebar(true)" icon-pack="feather" icon="icon-edit">
              Bulk Edit Operator's Equipment
            </vs-button>
            <vs-button class="rounded-lg mr-2" color="danger" @click="GetGrid" icon-pack="feather"
              icon="icon-refresh-ccw">Reload</vs-button>

            <vs-dropdown vs-trigger-click class="cursor-pointer mr-4">
              <div class="
                  p-4
                  border border-solid border-grey-light
                  rounded-full
                  d-theme-dark-bg
                  cursor-pointer
                  flex
                  items-center
                  justify-between
                  font-medium
                ">
                <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                  {{
                    filteredLinks.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : filteredLinks.length
                  }}
                  of {{ filteredLinks.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage = 10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
          <template slot="thead">
            <vs-th>Action</vs-th>
            <vs-th sort-key="equipmentName">Equipment</vs-th>
            <vs-th sort-key="equipmentTag">Equipment Tag</vs-th>
            <vs-th sort-key="operatorName">Employee</vs-th>
            <vs-th sort-key="operatorTag">Employee Tag</vs-th>
            <vs-th sort-key="isBlocked">Access</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr>
              <vs-td></vs-td>
              <vs-td>
                <vs-input v-model="queryEquipment" class="w-full" />
              </vs-td>
              <vs-td>
                <vs-input v-model="queryEquipmentTag" class="w-full" />
              </vs-td>
              <vs-td>
                <vs-input v-model="queryOperator" class="w-full" />
              </vs-td>
              <vs-td>
                <vs-input v-model="queryOperatorTag" class="w-full" />
              </vs-td>
              <vs-td></vs-td>
            </vs-tr>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="whitespace-no-wrap" id="iconContainer">
                <vx-tooltip class="flex" text="Remove Link">
                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                    @click.stop="deleteLink(tr)" />
                </vx-tooltip>
              </vs-td>
              <vs-td>{{ tr.equipmentName }}</vs-td>
              <vs-td>{{ tr.equipmentTag }}</vs-td>
              <vs-td>{{ tr.operatorName }}</vs-td>
              <vs-td>{{ tr.operatorTag }}</vs-td>
              <vs-td>
                <span class="font-semibold" :class="tr.isBlocked ? 'text-danger' : 'text-success'">
                  {{ tr.isBlocked ? 'Blocked' : 'Allowed' }}
                </span>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import equipmentOperatorSidebar from "./EquipmentOperatorSidebar.vue";
import equipmentOperatorBulkEditSidebar from "./EquipmentOperatorBulkEditSidebar.vue";

export default {
  components: {
    "equipment-operator-sidebar": equipmentOperatorSidebar,
    "equipment-operator-bulk-edit-sidebar": equipmentOperatorBulkEditSidebar
  },
  data() {
    return {
      links: [],
      originalLinks: [],
      selected: [],
      itemsPerPage: 20,
      currentPage: 1,
      addSidebarActive: false,
      bulkEditSidebarActive: false,
      queryEquipment: "",
      queryEquipmentTag: "",
      queryOperator: "",
      queryOperatorTag: ""
    };
  },
  computed: {
    filteredLinks() {
      var self = this;
      return self.originalLinks.filter(function (item) {
        return (
          (item.equipmentName || "").toLowerCase().includes((self.queryEquipment || "").toLowerCase()) &&
          (item.equipmentTag || "").toLowerCase().includes((self.queryEquipmentTag || "").toLowerCase()) &&
          (item.operatorName || "").toLowerCase().includes((self.queryOperator || "").toLowerCase()) &&
          (item.operatorTag || "").toLowerCase().includes((self.queryOperatorTag || "").toLowerCase())
        );
      });
    }
  },
  mounted() {
    this.GetGrid();
  },
  methods: {
    GetGrid() {
      const self = this;
      self.showLoadingOnElement("gridTable", 1, "radius");
      var onSuccess = function (response) {
        self.originalLinks = response.data || [];
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.gridTable.$el);
      };
      self.$ajaxGet(self, "PerEquipmentOperators/GetAll", onSuccess, onFinally);
    },
    toggleAddSidebar(val = false) {
      this.addSidebarActive = val;
    },
    toggleBulkEditSidebar(val = false) {
      this.bulkEditSidebarActive = val;
    },
    onLinkSaved() {
      this.GetGrid();
      this.successNotify();
    },
    deleteLink(row) {
      const self = this;
      if (!row || !row.id) return;
      self.showLoadingOnElement("gridTable", 1, "radius");
      var onSuccess = function () {
        self.GetGrid();
        self.successNotify();
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.gridTable.$el);
      };
      self.$ajaxDelete(self, "PerEquipmentOperators/" + row.id, onSuccess, onFinally);
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    successNotify() {
      this.$vs.notify({
        title: 'Successfully',
        text: 'Equipment / Operator link successfully saved | updated | removed',
        color: 'success'
      });
    },
    FailedNotify(msg) {
      this.$vs.notify({
        title: 'Not Successfull',
        text: msg || 'Action could not be completed',
        color: 'danger'
      });
    }
  }
};
</script>
